import { cva } from 'class-variance-authority'

export const layoutStyles = cva(
  `
    flex 
    flex-row
    h-screen
    w-full
    overflow-hidden
    background-app
  `
)

export const mainContentStyles = cva(
  `
    flex
    flex-col
    flex-1
    h-full
    min-w-0
    px-4
    py-6
    overflow-y-auto
    overflow-x-hidden
    bg-neutral-0
    rounded-none
    border-0
    rounded-tl-[40px]
    rounded-bl-[40px]
    border-l
    border-neutral-100

    sm:px-6
    sm:py-8
    md:px-14
    md:py-10
  `
)
